import React from "react";
import Dashboard from '../modules/Dashboard/Dashboard';

export function DashboardPage() {
  return <Dashboard />;
}
